import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "path3",
  "use": "path3-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"path3\"><path d=\"M18 24.5v4h-4v-4h4m2-2h-8v8h8v-8zM30 24.5v4h-4v-4h4m2-2h-8v8h8v-8z\" /><path d=\"M17 9.36v7.14H5v6h3v8H0v-8h3v-8h12V9.36a4 4 0 112 0zM27 18.5h2v2h-2zM27 14.5h2v2h-2z\" /><path d=\"M15 18.5h2v2h-2zM23 14.5h2v2h-2zM19 14.5h2v2h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/path3.svg
// module id = UdrE
// module chunks = 39 44